import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  FormControl,
  InputLabel,
  Select,
  TextField,
  MenuItem,
  SelectChangeEvent,
  Box,
} from "@mui/material";

import { IPairCommission } from "../GenerateGauntletReportDialog";
import { DEFAULT_TRADE_COMMISSION_PRICE } from "../../../../../constants";

interface IProps {
  options: string[];
  index: number;
  handleDeletePair: (index: number) => void;
  handleEditPair: (pair: IPairCommission, index: number) => void;
  pair: IPairCommission;
  selectedOptions: IPairCommission[];
  commissions: {
    [key: string]: number;
  };
}
const SelectPairPrice = ({
  options,
  index,
  handleDeletePair,
  handleEditPair,
  pair,
  selectedOptions,
  commissions,
}: IProps): React.ReactElement => {
  const onChangePair = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    handleEditPair(
      {
        // @ts-ignore
        price: commissions[value] || DEFAULT_TRADE_COMMISSION_PRICE,
        pair: value as string,
      },
      index
    );
  };
  const onChangeValue = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const { value } = event.target;
    handleEditPair(
      {
        ...pair,
        price: value as number,
      },
      index
    );
  };
  const handleDelete = () => handleDeletePair(index);

  return (
    <Box display="flex" flexDirection="row" py="10px" alignItems="center">
      <FormControl sx={{ mr: "10px" }}>
        <InputLabel>Pair</InputLabel>
        <Select
          variant="outlined"
          value={pair.pair}
          onChange={onChangePair}
          label="Pair"
          placeholder="Pair"
          name="pairName"
          inputProps={{
            name: "pairName",
          }}
          sx={{ minWidth: "195px" }}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              value={option}
              disabled={!!selectedOptions.find((op) => op.pair === option)}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl>
        <TextField
          name="price"
          label="Commission"
          type="number"
          value={pair.price}
          onChange={onChangeValue}
        />
      </FormControl>

      <CancelIcon onClick={handleDelete} color="secondary" sx={{ marginLeft: "10px" }} />
    </Box>
  );
};

export default SelectPairPrice;
